import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { useFormikContext } from "formik";
import { MultiValue, SingleValue } from "react-select";
import { CustomField } from "../customField.types";
import { OnLabelResolved } from "../customFieldSelector.types";
import {
  getSelectedComboboxOption,
  resolveSelectedOptionLabel,
} from "../customFieldSelector.utils";
import { useGetCountriesDataQuery } from "store/apis/onboarding";

type FormationTypeSelectorFieldProps = {
  field: CustomField;
  name: string;
  countryFieldName?: string;
  disabled?: boolean;
  onLabelResolved?: OnLabelResolved;
};

export const FormationTypeSelectorField = ({
  field,
  name,
  countryFieldName,
  disabled,
  onLabelResolved,
}: FormationTypeSelectorFieldProps) => {
  const { values } = useFormikContext<Record<string, string | string[]>>();
  const { data: countries = [], isLoading } = useGetCountriesDataQuery();

  const countryFieldValue = countryFieldName ? values[countryFieldName] : "";
  const countryId = Array.isArray(countryFieldValue) ? "" : countryFieldValue;

  const options: OptionData[] =
    countries
      .find((country) => country.uuid === countryId)
      ?.formation_type.map(({ name: formationName, uuid }) => ({
        label: formationName,
        value: uuid,
      })) ?? [];

  const selectedOption = getSelectedComboboxOption(
    options,
    values[name],
    field.is_multi_select
  );

  const handleChange = (
    option: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    const label = resolveSelectedOptionLabel(option);
    if (label) {
      onLabelResolved?.(name, label);
    }
  };

  return (
    <Combobox
      withForm
      name={name}
      label={field.label}
      placeholder={field.placeholder}
      required={field.is_required}
      tooltipText={field.tooltip}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isLoading={isLoading}
      isMulti={field.is_multi_select}
      isDisabled={disabled || !countryId}
      menuPortalTarget={document.body}
    />
  );
};
